import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import './custom-style.css'; // theme css file
import { DateRangePicker } from 'react-date-range';
import React from 'react';
import { CalendarTimeRange } from '../../store/store';
import Popover from '@material-ui/core/Popover';
import Button from '@material-ui/core/Button';
import DateRangeIcon from '@material-ui/icons/DateRange';
import moment from 'moment';

export const defaultTimeSelection = {
  startDate: new Date(),
  endDate: new Date(),
  key: 'selection',
};

export const defaultCallbacks = {
  setTime: (ev: any) => {
    console.log(ev);
  },
  onChange: (ev: any) => {
    console.log(ev);
  },
};

export type TimeSelection = typeof defaultTimeSelection;
const defaultProps = {
  ...defaultCallbacks,
  date: defaultTimeSelection,
};

export const DatePickers = (props = defaultProps) => {
  const state = { ...defaultProps, ...props };
  const { date } = state;
  const handleSelect = (ranges: any) => {
    const { selection } = ranges;
    const { endDate, startDate }: { endDate: Date; startDate: Date } =
      selection || ranges.range1;

    // ignore timezone and admit as UTC
    const dateNew: CalendarTimeRange = {
      endDate: moment.utc(endDate.toDateString()).toDate(),
      startDate: moment.utc(startDate.toDateString()).toDate(),
      key: 'selection',
    };

    state.setTime(dateNew);
    if (endDate !== startDate) {
      state.onChange(dateNew);
    }
  };
  return (
    <div>
      <DateRangePicker ranges={[date]} onChange={handleSelect} />
    </div>
  );
};

export const Wrapper = (props = defaultProps) => {
  const state = { ...defaultProps, ...props };
  state.date = { ...defaultProps.date, ...props.date };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { date } = state;

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>
      <Button aria-describedby={id} onClick={handleClick}>
        <DateRangeIcon />
        <div>
          {' '}
          <b>{date.startDate.toISOString().split('T')[0]}</b>
          <span> | </span>
          <b>{date.endDate.toISOString().split('T')[0]}</b>
        </div>
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <DatePickers {...state} />
      </Popover>
    </div>
  );
};
